import { clone } from 'lodash';
import {
  connectedFinancialInstitutions,
  connectedFinancialInstitutionPromise
} from './financialaccount.state';
import { FinancialInstitution } from '@/modules/predefined/models/FinancialInstitution';

export function setConnectedFinancialInstitutions(value: FinancialInstitution[]): void {
  connectedFinancialInstitutions.value = clone(value);
}

export function setConnectedPromise(promise: Promise<FinancialInstitution[]>): void {
  connectedFinancialInstitutionPromise.value = promise;
}
